






import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import { downloadFromUrl } from "@/shared/fileDownload";

@Component({
  components: {}
})
export default class DownloadLink extends Vue {
  @Prop({ required: true })
  url: string;

  @Prop({ required: false })
  fileName: string;

  onClick () {
    downloadFromUrl(this.url, this.fileName);
  }
}
